export default "__VITE_ASSET__5923146f__"